var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicroservice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.942
    },
    fill: "#ab00ff",
    d: "M 248.5,15.5 C 248.5,19.8333 248.5,24.1667 248.5,28.5C 238.646,29.4951 228.646,30.4951 218.5,31.5C 218.226,26.737 218.559,22.0704 219.5,17.5C 229.112,16.1258 238.779,15.4592 248.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.962
    },
    fill: "#b200ff",
    d: "M 248.5,15.5 C 259.86,15.2826 271.193,15.6159 282.5,16.5C 282.226,21.263 282.559,25.9296 283.5,30.5C 271.857,29.4794 260.191,28.8127 248.5,28.5C 248.5,24.1667 248.5,19.8333 248.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.939
    },
    fill: "#b800ff",
    d: "M 282.5,16.5 C 291.981,17.5242 301.314,19.1909 310.5,21.5C 311.441,26.0704 311.774,30.737 311.5,35.5C 302.207,33.6178 292.874,31.9512 283.5,30.5C 282.559,25.9296 282.226,21.263 282.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.95
    },
    fill: "#a500ff",
    d: "M 219.5,17.5 C 218.559,22.0704 218.226,26.737 218.5,31.5C 208.916,33.6881 199.249,36.0215 189.5,38.5C 189.5,33.8333 189.5,29.1667 189.5,24.5C 199.301,21.4058 209.301,19.0725 219.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.941
    },
    fill: "#be00ff",
    d: "M 310.5,21.5 C 321.311,23.6601 331.644,26.9934 341.5,31.5C 341.5,36.1667 341.5,40.8333 341.5,45.5C 331.478,41.937 321.478,38.6037 311.5,35.5C 311.774,30.737 311.441,26.0704 310.5,21.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.942
    },
    fill: "#a000ff",
    d: "M 189.5,24.5 C 189.5,29.1667 189.5,33.8333 189.5,38.5C 179.76,41.9689 170.094,45.6355 160.5,49.5C 160.135,44.9063 159.135,40.573 157.5,36.5C 167.56,31.143 178.227,27.143 189.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.939
    },
    fill: "#c500ff",
    d: "M 341.5,31.5 C 351.816,34.4935 361.483,38.8268 370.5,44.5C 370.821,49.6946 370.487,54.6946 369.5,59.5C 360.101,54.8007 350.768,50.134 341.5,45.5C 341.5,40.8333 341.5,36.1667 341.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.94
    },
    fill: "#9900ff",
    d: "M 157.5,36.5 C 159.135,40.573 160.135,44.9063 160.5,49.5C 148.353,55.4045 136.686,62.0712 125.5,69.5C 125.821,64.3054 125.487,59.3054 124.5,54.5C 134.414,46.7059 145.414,40.7059 157.5,36.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.934
    },
    fill: "#cb00ff",
    d: "M 370.5,44.5 C 382.908,50.6945 394.241,58.3612 404.5,67.5C 404.5,73.1667 404.5,78.8333 404.5,84.5C 393.324,75.4182 381.657,67.0848 369.5,59.5C 370.487,54.6946 370.821,49.6946 370.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.942
    },
    fill: "#9300ff",
    d: "M 124.5,54.5 C 125.487,59.3054 125.821,64.3054 125.5,69.5C 116.191,77.1367 106.858,84.8034 97.5,92.5C 96.5111,87.0247 96.1778,81.358 96.5,75.5C 104.751,67.0427 114.085,60.0427 124.5,54.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.951
    },
    fill: "#d100ff",
    d: "M 404.5,67.5 C 410.896,71.7172 416.896,76.5505 422.5,82C 427.192,86.5823 431.526,91.4157 435.5,96.5C 434.509,102.979 434.176,109.646 434.5,116.5C 425.572,104.902 415.572,94.2358 404.5,84.5C 404.5,78.8333 404.5,73.1667 404.5,67.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.938
    },
    fill: "#8d00ff",
    d: "M 96.5,75.5 C 96.1778,81.358 96.5111,87.0247 97.5,92.5C 86.5366,103.801 76.5366,115.801 67.5,128.5C 66.8333,121.833 66.1667,115.167 65.5,108.5C 74.0855,95.9128 84.4188,84.9128 96.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#b000ff",
    d: "M 248.5,95.5 C 271.409,94.2389 281.242,104.906 278,127.5C 274.91,134.924 269.577,139.924 262,142.5C 261.667,150.833 261.333,159.167 261,167.5C 257.333,171.5 253.667,171.5 250,167.5C 249.667,159.167 249.333,150.833 249,142.5C 231.788,134.342 227.455,121.675 236,104.5C 239.299,100.118 243.466,97.1179 248.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.942
    },
    fill: "#d700ff",
    d: "M 435.5,96.5 C 446.377,108.379 455.71,121.379 463.5,135.5C 463.827,144.682 463.493,153.682 462.5,162.5C 454.688,146.203 445.354,130.87 434.5,116.5C 434.176,109.646 434.509,102.979 435.5,96.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.94
    },
    fill: "#8700ff",
    d: "M 65.5,108.5 C 66.1667,115.167 66.8333,121.833 67.5,128.5C 54.7767,148.61 44.7767,169.944 37.5,192.5C 37.8286,179.989 37.4952,167.655 36.5,155.5C 44.2194,138.487 53.8861,122.82 65.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#9900ff",
    d: "M 159.5,129.5 C 159.5,149.167 159.5,168.833 159.5,188.5C 140.742,187.575 130.742,177.742 129.5,159C 130.742,140.258 140.742,130.425 159.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.978
    },
    fill: "#a000ff",
    d: "M 159.5,129.5 C 181.46,132.044 190.96,144.377 188,166.5C 187.22,169.512 186.053,172.345 184.5,175C 189.984,179.475 194.317,184.808 197.5,191C 195.045,197.152 191.045,198.485 185.5,195C 181.984,191.651 178.651,188.151 175.5,184.5C 170.515,187.274 165.182,188.607 159.5,188.5C 159.5,168.833 159.5,149.167 159.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#c500ff",
    d: "M 341.5,186.5 C 341.5,168.167 341.5,149.833 341.5,131.5C 357.589,126.365 370.089,131.031 379,145.5C 385.941,166.061 379.441,180.228 359.5,188C 354.5,188.667 349.5,188.667 344.5,188C 343.263,187.768 342.263,187.268 341.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.965
    },
    fill: "#c000ff",
    d: "M 341.5,131.5 C 341.5,149.833 341.5,168.167 341.5,186.5C 339.323,186.414 337.323,185.747 335.5,184.5C 331.411,189.925 326.411,194.258 320.5,197.5C 313.642,195.456 312.142,191.456 316,185.5C 319.349,181.984 322.849,178.651 326.5,175.5C 319.275,160.232 321.608,146.732 333.5,135C 335.818,133.007 338.484,131.841 341.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#de00ff",
    d: "M 463.5,135.5 C 495.887,192.718 504.054,253.385 488,317.5C 482.4,337.48 474.566,356.48 464.5,374.5C 463.833,365.833 463.167,357.167 462.5,348.5C 489.035,286.493 489.035,224.493 462.5,162.5C 463.493,153.682 463.827,144.682 463.5,135.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.942
    },
    fill: "#8200ff",
    d: "M 36.5,155.5 C 37.4952,167.655 37.8286,179.989 37.5,192.5C 29.1931,223.411 27.0264,254.745 31,286.5C 32.4226,297.785 34.9226,308.785 38.5,319.5C 37.5048,331.655 37.1714,343.989 37.5,356.5C 14.7781,306.83 9.27808,255.163 21,201.5C 24.8811,185.69 30.0478,170.356 36.5,155.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#b100ff",
    d: "M 284.5,200.5 C 283.17,206.631 282.503,213.131 282.5,220C 282.5,226.675 282.834,233.175 283.5,239.5C 274.563,245.643 265.23,251.31 255.5,256.5C 252.432,255.309 249.765,253.642 247.5,251.5C 248.497,230.34 248.831,209.007 248.5,187.5C 250.832,184.669 253.832,183.502 257.5,184C 266.564,189.525 275.564,195.025 284.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.981
    },
    fill: "#ab00ff",
    d: "M 248.5,187.5 C 248.831,209.007 248.497,230.34 247.5,251.5C 229.558,241.527 211.892,231.027 194.5,220C 212.141,208.516 230.141,197.683 248.5,187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.964
    },
    fill: "#b700ff",
    d: "M 284.5,200.5 C 295.305,206.738 305.972,213.238 316.5,220C 305.774,227.027 294.774,233.527 283.5,239.5C 282.834,233.175 282.5,226.675 282.5,220C 282.503,213.131 283.17,206.631 284.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#a500ff",
    d: "M 219.5,247.5 C 218.503,266.659 218.17,285.993 218.5,305.5C 208.807,300.234 199.307,294.567 190,288.5C 189.167,268.825 189.334,249.158 190.5,229.5C 200.398,235.275 210.065,241.275 219.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.973
    },
    fill: "#9200ff",
    d: "M 126.5,232.5 C 125.517,247.755 125.183,263.089 125.5,278.5C 107.343,281.333 97.3428,273.666 95.5,255.5C 97.5658,236.948 107.899,229.281 126.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#cb00ff",
    d: "M 370.5,265.5 C 370.823,259.31 370.49,253.31 369.5,247.5C 374.532,235.645 383.532,230.478 396.5,232C 411.706,236.564 417.873,246.731 415,262.5C 410.123,275.026 400.957,280.526 387.5,279C 379.274,277.596 373.607,273.096 370.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.964
    },
    fill: "#9800ff",
    d: "M 126.5,232.5 C 134.37,235.536 139.703,241.036 142.5,249C 150.833,249.333 159.167,249.667 167.5,250C 171.5,253.667 171.5,257.333 167.5,261C 159.167,261.333 150.833,261.667 142.5,262C 139.614,270.386 133.947,275.886 125.5,278.5C 125.183,263.089 125.517,247.755 126.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#b900ff",
    d: "M 282.5,311.5 C 282.83,291.993 282.497,272.659 281.5,253.5C 294.269,245.275 307.269,237.275 320.5,229.5C 321.666,249.158 321.833,268.825 321,288.5C 308.359,296.567 295.526,304.234 282.5,311.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.985
    },
    fill: "#ac00ff",
    d: "M 219.5,247.5 C 229.859,253.099 240.025,259.099 250,265.5C 250.833,285.175 250.666,304.842 249.5,324.5C 238.936,318.392 228.602,312.059 218.5,305.5C 218.17,285.993 218.503,266.659 219.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.936
    },
    fill: "#c400ff",
    d: "M 369.5,247.5 C 370.49,253.31 370.823,259.31 370.5,265.5C 369.751,264.469 369.085,263.302 368.5,262C 360.167,261.667 351.833,261.333 343.5,261C 339.5,257.333 339.5,253.667 343.5,250C 351.833,249.667 360.167,249.333 368.5,249C 369.056,248.617 369.389,248.117 369.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.949
    },
    fill: "#b300ff",
    d: "M 281.5,253.5 C 282.497,272.659 282.83,291.993 282.5,311.5C 275.732,316.059 268.732,320.392 261.5,324.5C 260.334,304.842 260.167,285.175 261,265.5C 267.642,261.098 274.475,257.098 281.5,253.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.959
    },
    fill: "#c000ff",
    d: "M 341.5,324.5 C 341.5,342.833 341.5,361.167 341.5,379.5C 328.891,374.811 322.557,365.645 322.5,352C 322.29,346.129 323.623,340.629 326.5,335.5C 320.852,331.359 316.519,326.193 313.5,320C 314.953,314.861 318.287,313.194 323.5,315C 327.981,318.314 331.981,322.148 335.5,326.5C 337.323,325.253 339.323,324.586 341.5,324.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#a000ff",
    d: "M 159.5,381.5 C 159.5,361.833 159.5,342.167 159.5,322.5C 165.182,322.393 170.515,323.726 175.5,326.5C 179.589,321.075 184.589,316.742 190.5,313.5C 197.358,315.544 198.858,319.544 195,325.5C 191.651,329.016 188.151,332.349 184.5,335.5C 192.574,352.508 189.241,366.674 174.5,378C 169.805,380.51 164.805,381.677 159.5,381.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.943
    },
    fill: "#8600ff",
    d: "M 38.5,319.5 C 44.868,341.233 54.2014,361.567 66.5,380.5C 66.825,388.019 66.4916,395.352 65.5,402.5C 54.1611,388.508 44.8278,373.174 37.5,356.5C 37.1714,343.989 37.5048,331.655 38.5,319.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#9900ff",
    d: "M 159.5,322.5 C 159.5,342.167 159.5,361.833 159.5,381.5C 140.742,380.575 130.742,370.742 129.5,352C 130.742,333.258 140.742,323.425 159.5,322.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.987
    },
    fill: "#c500ff",
    d: "M 341.5,379.5 C 341.5,361.167 341.5,342.833 341.5,324.5C 357.589,319.365 370.089,324.031 379,338.5C 384.579,353.01 381.746,365.51 370.5,376C 361.282,381.776 351.615,382.943 341.5,379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.971
    },
    fill: "#b000ff",
    d: "M 253.5,340.5 C 256.505,340.253 259.005,341.253 261,343.5C 261.333,351.833 261.667,360.167 262,368.5C 279.291,376.706 283.624,389.373 275,406.5C 262,419.833 249,419.833 236,406.5C 227.376,389.373 231.709,376.706 249,368.5C 249.333,360.167 249.667,351.833 250,343.5C 251.145,342.364 252.312,341.364 253.5,340.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.937
    },
    fill: "#d700ff",
    d: "M 462.5,348.5 C 463.167,357.167 463.833,365.833 464.5,374.5C 456.349,388.976 446.683,402.309 435.5,414.5C 434.833,408.167 434.167,401.833 433.5,395.5C 444.936,380.969 454.602,365.303 462.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.95
    },
    fill: "#d100ff",
    d: "M 433.5,395.5 C 434.167,401.833 434.833,408.167 435.5,414.5C 426.462,425.872 416.129,435.872 404.5,444.5C 404.5,438.5 404.5,432.5 404.5,426.5C 414.505,416.494 424.172,406.161 433.5,395.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.941
    },
    fill: "#9000ff",
    d: "M 66.5,380.5 C 82.4287,404.763 102.429,425.096 126.5,441.5C 126.215,446.859 125.215,451.859 123.5,456.5C 100.829,442.151 81.4961,424.151 65.5,402.5C 66.4916,395.352 66.825,388.019 66.5,380.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.939
    },
    fill: "#cb00ff",
    d: "M 404.5,426.5 C 404.5,432.5 404.5,438.5 404.5,444.5C 393.957,453.041 382.623,460.375 370.5,466.5C 370.821,461.305 370.487,456.305 369.5,451.5C 381.422,443.587 393.088,435.254 404.5,426.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.944
    },
    fill: "#9900ff",
    d: "M 126.5,441.5 C 137.211,449.19 148.544,455.857 160.5,461.5C 159.784,466.064 159.117,470.731 158.5,475.5C 146.026,470.434 134.36,464.1 123.5,456.5C 125.215,451.859 126.215,446.859 126.5,441.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.946
    },
    fill: "#c400ff",
    d: "M 369.5,451.5 C 370.487,456.305 370.821,461.305 370.5,466.5C 361.483,472.173 351.816,476.507 341.5,479.5C 341.774,474.737 341.441,470.07 340.5,465.5C 350.315,461.092 359.982,456.425 369.5,451.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.943
    },
    fill: "#9f00ff",
    d: "M 160.5,461.5 C 170.094,465.364 179.76,469.031 189.5,472.5C 189.5,477.167 189.5,481.833 189.5,486.5C 178.795,483.821 168.462,480.154 158.5,475.5C 159.117,470.731 159.784,466.064 160.5,461.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.943
    },
    fill: "#be00ff",
    d: "M 340.5,465.5 C 341.441,470.07 341.774,474.737 341.5,479.5C 332.18,483.607 322.514,486.941 312.5,489.5C 311.559,484.93 311.226,480.263 311.5,475.5C 321.22,472.592 330.887,469.259 340.5,465.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.942
    },
    fill: "#a500ff",
    d: "M 189.5,472.5 C 199.249,474.979 208.916,477.312 218.5,479.5C 218.818,484.032 218.485,488.366 217.5,492.5C 207.939,491.442 198.606,489.442 189.5,486.5C 189.5,481.833 189.5,477.167 189.5,472.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.945
    },
    fill: "#b800ff",
    d: "M 311.5,475.5 C 311.226,480.263 311.559,484.93 312.5,489.5C 303.199,491.383 293.866,493.05 284.5,494.5C 282.867,490.059 281.867,485.392 281.5,480.5C 291.544,479.091 301.544,477.425 311.5,475.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.934
    },
    fill: "#ab00ff",
    d: "M 218.5,479.5 C 228.645,480.505 238.645,481.505 248.5,482.5C 248.5,486.833 248.5,491.167 248.5,495.5C 237.906,495.728 227.573,494.728 217.5,492.5C 218.485,488.366 218.818,484.032 218.5,479.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.954
    },
    fill: "#b200ff",
    d: "M 281.5,480.5 C 281.867,485.392 282.867,490.059 284.5,494.5C 272.52,495.338 260.52,495.672 248.5,495.5C 248.5,491.167 248.5,486.833 248.5,482.5C 259.528,482.145 270.528,481.479 281.5,480.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroservice);
export default __webpack_public_path__ + "static/media/microservice.3c13e79ca1f81cc09028dbea5492a9d1.svg";
export { ForwardRef as ReactComponent };